"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Localized = void 0;
const model_1 = require("./model");
const utils_1 = require("./utils");
const GermanLocale = {
    states: [
        { name: "Baden-Württemberg", code: "BW" },
        { name: "Bayern", code: "BY" },
        { name: "Augsburg, Bayern", code: "AB" },
        { name: "Berlin", code: "BE" },
        { name: "Brandenburg", code: "BB" },
        { name: "Bremen", code: "HB" },
        { name: "Hamburg", code: "HH" },
        { name: "Hessen", code: "HE" },
        { name: "Mecklenburg-Vorpommern", code: "MV" },
        { name: "Niedersachsen", code: "NI" },
        { name: "Nordrhein-Westfalen", code: "NW" },
        { name: "Rheinland-Pfalz", code: "RP" },
        { name: "Saarland", code: "SL" },
        { name: "Sachsen", code: "SN" },
        { name: "Sachsen-Anhalt", code: "ST" },
        { name: "Schleswig-Holstein", code: "SH" },
        { name: "Thüringen", code: "TH" },
    ],
    // OpenHolidays uses alternative state codes for Germany so we need to map them to the ISO state codes
    openHolidayStateCodes: {
        BW: "BW",
        BY: "BY",
        AB: "BY",
        BE: "BE",
        BB: "BB",
        HB: "HB",
        HH: "HH",
        HE: "HE",
        // MV splits school holidays into Allgemeinbildende Schulen (ABS) and Berufsbildende Schulen (BBS)
        // We only use the ABS holidays for now
        "MV-ABS": "MV",
        NI: "NI",
        NW: "NW",
        RP: "RP",
        SL: "SL",
        SN: "SN",
        ST: "ST",
        SH: "SH",
        TH: "TH",
    },
    maxWorkingHoursPerDay: 10,
    minRestingHours: 11,
    timeEntryTypeLabel(type) {
        switch (type) {
            case model_1.TimeEntryType.Work:
                return "Arbeit";
            case model_1.TimeEntryType.Vacation:
                return "Urlaub";
            case model_1.TimeEntryType.Sick:
                return "Krank";
            case model_1.TimeEntryType.ChildSick:
                return "Kind Krank";
            case model_1.TimeEntryType.SickInKUG:
                return "Krank in KUG";
            case model_1.TimeEntryType.School:
                return "Schule";
            case model_1.TimeEntryType.HourAdjustment:
                return "Zeitbuchung";
            case model_1.TimeEntryType.VacationAdjustment:
                return "Urlaubsbuchung";
            case model_1.TimeEntryType.Free:
                return "Frei";
            case model_1.TimeEntryType.CompDay:
                return "Guttag";
            default:
                return "";
        }
    },
    timeEntryTypeIcon(type) {
        switch (type) {
            case model_1.TimeEntryType.Work:
                return "digging";
            case model_1.TimeEntryType.Vacation:
                return "island-tropical";
            case model_1.TimeEntryType.Sick:
            case model_1.TimeEntryType.SickInKUG:
                return "face-thermometer";
            case model_1.TimeEntryType.ChildSick:
                return "baby";
            case model_1.TimeEntryType.HourAdjustment:
            case model_1.TimeEntryType.VacationAdjustment:
                return "plus-minus";
            case model_1.TimeEntryType.Free:
                return "couch";
            case model_1.TimeEntryType.CompDay:
                return "gift";
            default:
                return "";
        }
    },
    mapOpenHoliday(holiday) {
        var _a;
        return {
            ..._getSchoolHolidayCoreData(holiday),
            states: holiday.nationwide
                ? GermanLocale.states.map((s) => s.code)
                : ((_a = holiday.subdivisions) === null || _a === void 0 ? void 0 : _a.map((s) => GermanLocale.openHolidayStateCodes[s.shortName])) || [],
        };
    },
};
const AustrianLocale = {
    states: [
        { name: "Burgenland", code: "AT-1" },
        { name: "Kärnten", code: "AT-2" },
        { name: "Niederösterreich", code: "AT-3" },
        { name: "Oberösterreich", code: "AT-4" },
        { name: "Salzburg", code: "AT-5" },
        { name: "Steiermark", code: "AT-6" },
        { name: "Tirol", code: "AT-7" },
        { name: "Vorarlberg", code: "AT-8" },
        { name: "Wien", code: "AT-9" },
    ],
    // OpenHolidays uses alternative state codes for Austria so we need to map them to the ISO state codes
    openHolidayStateCodes: {
        BL: "AT-1",
        KÄ: "AT-2",
        NÖ: "AT-3",
        OÖ: "AT-4",
        SB: "AT-5",
        SM: "AT-6",
        TI: "AT-7",
        VA: "AT-8",
        WI: "AT-9",
    },
    maxWorkingHoursPerDay: 12,
    minRestingHours: 11,
    timeEntryTypeLabel(type) {
        switch (type) {
            case model_1.TimeEntryType.ChildSick:
                return "Pflegeurlaub";
            default:
                return GermanLocale.timeEntryTypeLabel(type);
        }
    },
    timeEntryTypeIcon(type) {
        switch (type) {
            case model_1.TimeEntryType.ChildSick:
                return "hand-holding-medical";
            default:
                return GermanLocale.timeEntryTypeIcon(type);
        }
    },
    mapOpenHoliday(holiday) {
        var _a;
        return {
            ..._getSchoolHolidayCoreData(holiday),
            states: holiday.nationwide
                ? AustrianLocale.states.map((s) => s.code)
                : ((_a = holiday.subdivisions) === null || _a === void 0 ? void 0 : _a.map((s) => AustrianLocale.openHolidayStateCodes[s.shortName])) || [],
        };
    },
};
function _getSchoolHolidayCoreData(holiday) {
    var _a;
    return {
        start: holiday.startDate,
        // OpenHolidays end days are inclusive, whereas in Pentacode end dates are exclusive
        end: (0, utils_1.dateAdd)(holiday.endDate, { days: 1 }),
        name: ((_a = holiday.name.find((n) => n.language === "DE")) === null || _a === void 0 ? void 0 : _a.text) || holiday.name[0].text || "Unbenannt",
    };
}
exports.Localized = {
    DE: GermanLocale,
    AT: AustrianLocale,
};
//# sourceMappingURL=localized.js.map